// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2pelK","inputWrap":"CustomTip_inputWrap__Drmzc"};